import { defineComponent as i, computed as t, openBlock as a, createElementBlock as l, normalizeStyle as c, normalizeClass as d, toDisplayString as u, createCommentVNode as m, createElementVNode as p, renderSlot as _ } from "vue";
const h = {
  key: 0,
  class: "base-list__subheader",
  role: "heading",
  "aria-level": "3"
}, b = { class: "base-list__items" }, v = /* @__PURE__ */ i({
  __name: "BaseList",
  props: {
    subheader: {},
    gap: { default: "0px" }
  },
  setup(e) {
    const o = e, r = t(() => ["base-list"].join(" ")), n = t(() => ({
      "--list-gap": o.gap
    }));
    return (s, f) => (a(), l("ul", {
      class: d(r.value),
      style: c(n.value),
      role: "list"
    }, [
      e.subheader ? (a(), l("div", h, u(e.subheader), 1)) : m("", !0),
      p("div", b, [
        _(s.$slots, "default")
      ])
    ], 6));
  }
});
export {
  v as default
};
